import axios from 'axios';
import AuthService from './auth';

// 约定：前端所有管理 API 走 /api/admin/*（由 webpack devServer proxy 转发到后端 mall-server）
const instance = axios.create({
  baseURL: '/api',
  timeout: 15000,
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken?.();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (resp) => {
    // 对于下载/导出等二进制响应，直接返回原始 response
    if (resp?.config?.responseType === 'blob') return resp;
    const data = resp?.data;

    // 统一将后端 {code, message, data} 规范化为 {success, code, message, data}
    if (data && typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'success')) return data;

      if (data.code === 200 || data.code === 0) {
        return { success: true, ...data };
      }

      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        return { success: false, ...data };
      }
    }

    return data;
  },
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    error.status = status;
    error.code = data?.code || error.code;
    error.appMessage =
      data?.message ||
      (status === 403 ? '没有执行该操作的权限' : null) ||
      (status >= 500 ? '服务暂时不可用，请稍后重试' : null) ||
      (!error.response ? '网络连接失败，请检查网络后重试' : null) ||
      error.message;

    if (status === 401) {
      AuthService.handleAuthFailure?.();
    }
    if (status === 403 && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('admin:forbidden', {
        detail: { message: error.appMessage }
      }));
    }
    return Promise.reject(error);
  }
);

export default instance;

